import axiosInstance from '@/api/axiosInstance'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

const CONVERSATIONS_PATH = '/conversations/'

export const useConversations = () => {
    return useQuery({
        queryKey: ['conversations'],
        queryFn: async () => {
            const response = await axiosInstance.get(CONVERSATIONS_PATH)
            return response.data.results || response.data
        },
        staleTime: 30 * 1000,
        refetchInterval: 60 * 1000,
    })
}

export const useMessages = (conversationId: number) => {
    return useQuery({
        queryKey: ['conversations', conversationId, 'messages'],
        queryFn: async () => {
            const response = await axiosInstance.get(`${CONVERSATIONS_PATH}${conversationId}/messages/`)
            return response.data
        },
        enabled: !!conversationId,
        staleTime: 10 * 1000,
        refetchInterval: 5 * 1000,
    })
}

export const useSendMessage = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (data: { conversation: number; content: string }) => {
            const response = await axiosInstance.post(
                `${CONVERSATIONS_PATH}${data.conversation}/messages/`,
                { content: data.content }
            )
            return response.data
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['conversations'] })
            queryClient.invalidateQueries({ queryKey: ['conversations', variables.conversation, 'messages'] })
        },
    })
}

export const useMarkMessagesRead = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: async (conversationId: number) => {
            await axiosInstance.get(`${CONVERSATIONS_PATH}${conversationId}/messages/`)
        },
        onSuccess: (_, conversationId) => {
            queryClient.invalidateQueries({ queryKey: ['conversations'] })
            queryClient.invalidateQueries({ queryKey: ['conversations', conversationId, 'messages'] })
        },
    })
}


